import { render } from "./Auth.vue?vue&type=template&id=678459a5&bindings={}"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
script.render = render

export default script